"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caltrano": {
    "3fe0eb14": [{
      "hkey": "9fa147c4",
      "slug": "campora-tezze",
      "name": "Campora-Tezze",
      "primary": true,
      "skipSearch": false
    }],
    "campora": [{
      "hkey": "9fa147c4",
      "slug": "campora-tezze",
      "name": "Campora-Tezze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e13b39cd": [{
      "hkey": "f1c92dca",
      "slug": "caltrano",
      "name": "Caltrano",
      "primary": true,
      "skipSearch": false
    }],
    "castellan": [{
      "hkey": "f1c92dca",
      "slug": "caltrano",
      "name": "Caltrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c05dfc57": [{
      "hkey": "f1c92dca",
      "slug": "caltrano",
      "name": "Caltrano",
      "primary": true,
      "skipSearch": false
    }],
    "grumi": [{
      "hkey": "f1c92dca",
      "slug": "caltrano",
      "name": "Caltrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f301c87": [{
      "hkey": "1f1e4fde",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "mosson": [{
      "hkey": "1f1e4fde",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltrano"
    }],
    "223ff1e6": [{
      "hkey": "fb92639f",
      "slug": "camisino",
      "name": "Camisino",
      "primary": true,
      "skipSearch": false
    }],
    "sandona": [{
      "hkey": "fb92639f",
      "slug": "camisino",
      "name": "Camisino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltrano"
    }],
    "260368d1": [{
      "hkey": "9fa147c4",
      "slug": "campora-tezze",
      "name": "Campora-Tezze",
      "primary": true,
      "skipSearch": false
    }],
    "tezze": [{
      "hkey": "9fa147c4",
      "slug": "campora-tezze",
      "name": "Campora-Tezze",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltrano"
    }]
  }
};
exports["default"] = _default;